













































import {
	computed,
	defineComponent,
	PropType,
} from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import IconButton from '@front-app/components/buttons/IconButton.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import { Spacing } from '@front-app/components/constants';

export default defineComponent({
	components: {
		FontAwesomeIcon,
		IconButton,
		SimpleCard,
	},
	props: {
		closeButtonAriaLabel: {
			type: String,
			required: true,
		},
		spacing: {
			type: String as PropType<Spacing>,
			default: Spacing.REGULAR,
		},
		isDisplayed: Boolean,
		hasError: Boolean,
		hasWarning: Boolean,
		hasSuccess: Boolean,
	},
	setup(props) {
		const slotName = computed(() => {
			if (props.hasError) {
				return 'error';
			}
			if (props.hasWarning) {
				return 'warning';
			}
			if (props.hasSuccess) {
				return 'success';
			}
			return null;
		});
		return { slotName };
	},
});
